import { render } from "./addApt.vue?vue&type=template&id=31f4c130&scoped=true"
import script from "./addApt.vue?vue&type=script&lang=js"
export * from "./addApt.vue?vue&type=script&lang=js"

import "./addApt.vue?vue&type=style&index=0&id=31f4c130&lang=scss&scoped=true"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f4c130"]])

export default __exports__